<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :style="{width:'100%' }"
      :close-on-popstate="true"
      :close-on-click-overlay="false"
      class="carFlights full-height linear-main3"
    >
      <ld-header
        @click-left="isShow=false"
        :transparent="true"
        :white="true"
      >
        <span v-show="dateObj.monDay">{{ dateObj.monDay }}{{ dateObj.week }}</span>
      </ld-header>
      <div class="flightwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div class="pad-6">
            <div
              v-for="(info,index1) in list"
              :key="index1"
            >
              <transition name="van-slide-right">
                <div
                  class="pad-b-5"
                  v-show="info.isShow"
                  @click="selected(info)"
                >
                  <flight :flight-obj="info" :shname="true">
                    <span slot="departCityName">{{ info.departCityName }}-</span> 
                    <span slot="arriveCityName">{{ info.arriveCityName }}-</span> 
                    <span slot="departDate">{{ info.departDate }}</span>
                  </flight>
                </div>
              </transition>
            </div>
            <no-more :data="data" />
          </div>
        </mescroll-vue>
      </div>
      <!--  -->
      <!-- 底部菜单 -->
      <ld-tabbar class="shadow bg-white">
        <van-row
          type="flex"
          align="center"
          class=" full-width text-center font12 "
        >
          <van-col
            span="12"
            @click="fliters(1)"
          >
            <ld-icon
              class="icon"
              gradient
              icon-class="linear-main2"
              type="iconico_home_committed"
            />
            <div>时间  <span v-show="v==2">早-晚</span> <span v-show="v==1">晚-早</span></div>
          </van-col>
          <van-col
            span="12"
            @click="showFliter"
          >
            <ld-icon
              class="icon"
              gradient
              icon-class="linear-main2"
              type="iconshaixuan1"
            />
            <div>{{ $t('C121','筛选') }}</div>
          </van-col>
        </van-row>
      </ld-tabbar>
      <!--  -->
      <van-popup
        v-model="fliterIsShow"
        :close-on-popstate="true"
        position="bottom"
      >
        <van-tree-select
          :items="items"
          :main-active-index.sync="index"
        >
          <template slot="content">
            <!-- 时间 -->
            <div v-show="index==0">
              <van-cell-group>
                <van-cell :title="$t('F223','不限')">
                  <van-checkbox
                    slot="right-icon"
                    v-model="nolimitobj.seltime"
                    @click="nolimit('seltime',nolimitobj.seltime)"
                  />
                </van-cell>
                <van-cell
                  v-for="(t,index2) in depTime"
                  :key="index2"
                  :title="t.name"
                >
                  <van-checkbox
                    v-model="t.checked"
                    slot="right-icon"
                    @change="getTerm(0,t.name,t.checked)"
                  />
                </van-cell>
              </van-cell-group>
            </div>
            <!-- 起飞降落 -->
            <div v-show="index==1">
              <van-cell> {{ $t('Form','起飞') }} </van-cell>
              <van-cell-group>
                <van-cell :title="$t('F223','不限')">
                  <van-checkbox
                    slot="right-icon"
                    v-model="nolimitobj.seldepPlane"
                    @click="nolimit('seldepPlane',nolimitobj.seldepPlane)"
                  />
                </van-cell>
                <van-cell
                  v-for="(t,index3) in depPlane"
                  :key="'b'+index3"
                  :title="t.name"
                >
                  <van-checkbox
                    v-model="t.checked"
                    slot="right-icon"
                    @change="getTerm(1,t.name,t.checked)"
                  />
                </van-cell>
              </van-cell-group>

              <van-cell> 降落 </van-cell>
              <van-cell-group>
                <van-cell :title="$t('F223','不限')">
                  <van-checkbox
                    slot="right-icon"
                    v-model="nolimitobj.selarrPlane"
                    @click="nolimit('selarrPlane',nolimitobj.selarrPlane)"
                  />
                </van-cell>
                <van-cell
                  v-for="(t,index4) in arrPlane"
                  :key="'c'+index4"
                  :title="t.name"
                >
                  <van-checkbox
                    v-model="t.checked"
                    slot="right-icon"
                    @change="getTerm(2,t.name,t.checked)"
                  />
                </van-cell>
              </van-cell-group>
            </div>

            <div v-show="index==2">
              <van-cell-group>
                <van-cell :title="$t('F223','不限')">
                  <van-checkbox
                    v-model="nolimitobj.selhkgs"
                    slot="right-icon"
                    @click="nolimit('selhkgs',nolimitobj.selhkgs)"
                  />
                </van-cell>
                <van-cell
                  v-for="(h,index6) in hkgs"
                  :key="index6"
                  :title="h.name"
                >
                  <van-checkbox
                    v-model="h.checked"
                    slot="right-icon"
                    @change="getTerm(4,h.name,h.checked)"
                  />
                </van-cell>
              </van-cell-group>
            </div>
          <!-- <div
            v-show="index==3"
          >
            <van-checkbox
              v-model="nolimitobj.selcabin"
            >
              不限
            </van-checkbox>
            <van-checkbox
              v-for="(t,index5) in canbin"
              :key="'d'+index5"
              v-model="t.checked"
              @change="getTerm(3,t.name,t.checked)"
            >
              {{ t.name }}
            </van-checkbox>
          </div> -->
          </template>
        </van-tree-select>

        <van-row>
          <van-col span="12">
            <ld-button
              @click="clearing"
            >
              重置筛选
            </ld-button>
          </van-col>
          <van-col span="12">
            <ld-button
              @click="ensure"
              main
              md
            >
              {{ $t('Display','显示结果') }}
            </ld-button>
          </van-col>
        </van-row>
      </van-popup>
    <!--  -->
    </van-popup>
  </div>
</template>

<script>
import { Popup ,TreeSelect,Checkbox,Cell,CellGroup} from 'vant'
import flight from 'Components/tk/flight'
import noMore from 'Common/ldNoMore'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { formatDate } from 'Utils/dateUtil'

export default {
  name: 'CarFlights',
  components: {
    [Popup.name]:Popup,
    [TreeSelect.name]:TreeSelect,
    [Checkbox.name]:Checkbox,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    noMore,
    flight,
    ldTabbar,
    ldButton,
    MescrollVue
  },
  props: {
    data:{
      type:Array,
      default:function(){
        return []
      }
    },
    date:{
      type:String,
      default:''
    },
    useType:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      down:{use:false},
      isShow: false,
      keyWorlds: '',
      searchList: [],
      list: [],
      v:1,
      fliterIsShow:false,
      depTime: [
        { name: '00:00-06:00', checked: false },
        { name: '06:00-12:00', checked: false },
        { name: '12:00-18:00', checked: false },
        { name: '18:00-24:00', checked: false }
      ],
      hkgs: [],
      arrPlane: [],
      depPlane: [],
            
      index: 0,
      nolimitobj: {
        seltime: true,
        seldepPlane: true,
        selarrPlane: true,
        selhkgs: true
      },
      items: [{ text: '起飞时间' }, { text: '机场' }, { text: '航空公司' }],
      timearr:[],
      deparr:[],
      arrarr:[],
      cabinarr:[],
      hkgsarr:[],
    }
  },
  computed:{
    dateObj(){
      if(this.date){
        return formatDate(this.date)
      }
      return {}
    },
  },
  methods: {
    showFliter(){
      this.fliterIsShow = !this.fliterIsShow
    },
    getplane(m) {//获取机场  航空公司  数据
      if (this.list.length==0) return 
      let getData=(m)=> {
        for (let ke in this.list) {
          let value = this.list[ke][m] || ''
          if (value !== '' && obj.indexOf(value) < 0) {
            obj.push(value)
          }
        }
        for (let i = 0; i < obj.length; i++) {
          obj2.push({ name: obj[i], checked: false })
        }
      }
            
      let obj = []
      let obj2 = []
      switch (m) {
        case 0:
          getData('departAirportName')
          break
        case 1:
          getData('arriveAirportName')
          break
        case 2:
          getData('airlineName')
          break
      }
	
      return obj2
    },
    getTerm(m, n, k) {//获取选中数据
      switch (m) {
      //起飞时间
        case 0:
          for (let i = 0; i < this.depTime.length; i++) {
            let index = this.timearr.indexOf(n)
            if (k && index < 0) {
              this.timearr.push(n)
            } else if (!k && index >= 0) {
              this.timearr.splice(index, 1)
            }
          }
          break
        //起飞机场
        case 1:
          for (let i = 0; i < this.depPlane.length; i++) {
            let index = this.deparr.indexOf(n)
            if (k && index < 0) {
              this.deparr.push(n)
            } else if (!k && index >= 0) {
              this.deparr.splice(index, 1)
            }
          }
          break
        //到达机场
        case 2:
          for (let i = 0; i < this.arrPlane.length; i++) {
            let index = this.arrarr.indexOf(n)
            if (k && index < 0) {
              this.arrarr.push(n)
            } else if (!k && index >= 0) {
              this.arrarr.splice(index, 1)
            }
          }
          break
        //舱位类型
        case 3:
          for (let i = 0; i < this.canbin.length; i++) {
            let index = this.cabinarr.indexOf(n)
            if (k && index < 0) {
              this.cabinarr.push(n)
            } else if (!k && index >= 0) {
              this.cabinarr.splice(index, 1)
            }
          }
          break
        //航空公司
        case 4:
          for (let i = 0; i < this.hkgs.length; i++) {
            let index = this.hkgsarr.indexOf(n)
            if (k && index < 0) {
              this.hkgsarr.push(n)
            } else if (!k && index >= 0) {
              this.hkgsarr.splice(index, 1)
            }
          }
          break
      }
      if(this.timearr.length > 0){
        this.nolimitobj.seltime = false
      }else{
        this.nolimitobj.seltime = true
      }
      if(this.deparr.length > 0){
        this.nolimitobj.seldepPlane = false
      }else{
        this.nolimitobj.seldepPlane = true
      }
      if(this.arrarr.length > 0){
        this.nolimitobj.selarrPlane = false
      }else{
        this.nolimitobj.selarrPlane = true
      }
      // this.cabinarr.length > 0
      // 	? (this.nolimitobj.selcabin = false)
      // 	: (this.nolimitobj.selcabin = true)
      if(this.hkgsarr.length > 0){
        this.nolimitobj.selhkgs = false
      }else{
        this.nolimitobj.selhkgs = true
      }
            
    },
    //不限
    nolimit(n) {
      switch (n) {
        case 'seltime':
          getfs(this.depTime)
          break
        case 'seldepPlane':
          getfs(this.depPlane)
          break
        case 'selarrPlane':
          getfs(this.arrPlane)
          break
        case 'selcabin':
          getfs(this.canbin)
          break
        case 'selhkgs':
          getfs(this.hkgs)
          break
      }
      function getfs(m) {
        for (let i = 0; i < m.length; i++) {
          m[i].checked = false
        }
      }
            
    },
    clearing() {
      let arr = ['seltime', 'seldepPlane', 'selarrPlane', 'hkgsarr']
      for (let i = 0; i < arr.length; i++) {
        this.nolimit(arr[i])
      }
    },
    //确定
    ensure() {
      let st = [
        this.depTime,
        this.depPlane,
        this.arrPlane,
        // this.canbin,
        this.hkgs
      ]
      for (let i = 0,t=[0,1,2,4]; i <t .length; i++) {
        for (let j = 0; j < st[i].length; j++) {
          this.getTerm(t[i], st[i][j].name, st[i][j].checked)
        }
      }
      let flightList = this.list
      for (let i = 0; i < flightList.length; i++) {
        flightList[i].isShow = true
      }

      let result=(name , arr) =>{//筛选结果
        let obj={
          departTime(){
            flightList.forEach(el=>{
              let bl=arr.some(item=>{
                let start=item.split('-')[0]
                let end=item.split('-')[1]
                return el[name]>=start&&el[name]<=end
              })
              if(bl){ el.isShow=true}else {el.isShow=false}
            })
          },
          departTimes(){
            flightList.forEach(el=>{
              let bl=arr.some(item=>{
                let start=item.split('-')[0]
                let end=item.split('-')[1]
                return el[name]>=start&&el[name]<=end
              })
              if(bl){ el.isShow=true}else {el.isShow=false}
            })
          },
          departAirportName:some,
          arriveAirportName:some,
          airlineName:some
        }
        obj[name](name,arr)
      }
      let some=(name,arr)=>{
        flightList.forEach(el=>{
          let bl=arr.some(item=>{
            return el[name]==item
          })
          if(bl){ el.isShow=true}else {el.isShow=false}
        })
      }
            
      if(this.timearr.length > 0){
        if(this.list[0].departTimes){
          result('departTimes', this.timearr)//出发时间
        }else{
          result('departTime', this.timearr)//出发时间
        }
      }
      if(this.deparr.length > 0){
        result('departAirportName', this.deparr)//起飞机场
      }
      if(this.arrarr.length > 0){
        result('arriveAirportName', this.arrarr)//到达机场
      }
      // this.cabinarr.length > 0
      // 	? (this.nolimitobj.selcabin = false)
      // 	: (this.nolimitobj.selcabin = true)
      if(this.hkgsarr.length > 0){
        result('airlineName', this.hkgsarr)//航空公司
      }

      this.list = flightList

      this.fliterIsShow = false
    },
    //排序
    fliters(n) {
      let flightList = this.list
      switch (n) {
        case 1:
          if (this.v == 1 || this.v == 0) {
            this.v = 2
          } else {
            this.v = 1
          }
          this.list =flightList.sort((a,b)=>{
            let r=false
            if(b.departTime){
              r = b.departTime > a.departTime
            }else{
              r = b.departTimes > a.departTimes
            }
            return this.v == 1?(r ? 1 : -1):(r ? -1 : 1)
          })
          break
        case 2:
          if (this.v == 4) {
            this.v = 3
          } else {
            this.v = 4
          }
          this.list =flightList.sort((a,b)=>{
            return this.v == 3?(b.salePrice-a.salePrice):(a.salePrice-b.salePrice)
          })
          break
      }
    },
    getList(){
      this.data.forEach(item=>{
        item.isShow=true
      })
      this.list=this.data
      this.v = 1
      this.fliters(1)
      this.depPlane = this.getplane(0)
      this.arrPlane = this.getplane(1)
      this.hkgs = this.getplane(2)
      // this.$api['carQuery/queryWcxOrder']({
      // 	ywlx: 1
      // }).then(res => {
      // 	let cache = res.data || []
      // 	this.list = cache 
      // })
    },
    selected(info){
      if(this.useType==false){
        info.departTimes=''
        info.arriveTimes=''
      }
      var newArriveDate = ''
      newArriveDate = formatDate(new Date(this.dateObj.date),info.travelDay).date
      info.departTime = (this.dateObj.date&&info.departTime.length==5) ? (`${this.dateObj.date} ` + info.departTime) : info.departTime
      this.$store.commit('car/CARNodata',info)
      this.$emit('selected',info,newArriveDate)
      this.toggle()
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if(this.isShow){
        Object.assign(this,obj)
        this.getList()
      }
    }
  },
  watch: {
    type() {
      this.list = []
      this.getList()
    },
    'data.length'(){
      this.list = []
      this.getList()
    }
  },
  directives: {
  }
}
</script>

<style  lang="less" scoped>
@import '~Assets/styles/business';
.carFlights{
}
.pad-b-5{
padding-bottom: 5px;
}
.pad-6{
    padding:6px;
}
.icon{
    font-size: 18px;
    height: 18px;
}
.flightwrapper{
    height: calc(100vh - 96px);
    overflow: hidden;
}
</style>
